import Vue from 'vue';
import VueI18n from 'vue-i18n';
import ptBr from '../locales/pt-br';
import store from '../store/store';

// Encapsula todas as mensagens de internacionalização
const messages = {
  "pt-br": ptBr
}

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: store.getters.locale, // set locale
  messages, // set locale messages
  devtool: 'source-map',
  silentTranslationWarn: true,
})

// Fix para poder utilizar internacionalização nos componentes que são criados dinamicamente,
// como por exemplo os Dialogs
Vue.prototype.$t = (key, ...args) => i18n.t(key, args);

export default i18n;
